import React from 'react';
import { Card, CardContent } from '../../ui/card';

export const IntelligenceSummaryCards = ({ totalCalls, totalLowScore, topFailure, excellentRate }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
    <Card className="border-slate-200 shadow-sm" data-testid="intel-total-calls">
      <CardContent className="pt-5">
        <p className="text-xs text-slate-500 mb-1">Total Calls Analysed</p>
        <p className="text-3xl font-bold text-slate-900">{totalCalls}</p>
      </CardContent>
    </Card>
    <Card className="border-amber-100 bg-amber-50 shadow-sm" data-testid="intel-coaching-focus-calls">
      <CardContent className="pt-5">
        <p className="text-xs text-amber-700 mb-1">Calls With Coaching Opportunity</p>
        <p className="text-3xl font-bold text-amber-700">{totalLowScore}</p>
      </CardContent>
    </Card>
    <Card className="border-indigo-100 bg-indigo-50 shadow-sm">
      <CardContent className="pt-5">
        <p className="text-xs text-indigo-700 mb-1">Top Coaching Focus</p>
        <p className="text-sm font-bold text-indigo-800 leading-tight mt-1">
          {topFailure ? `${topFailure.split(' ').slice(0, 4).join(' ')}...` : '—'}
        </p>
      </CardContent>
    </Card>
    <Card className="border-emerald-100 bg-emerald-50 shadow-sm">
      <CardContent className="pt-5">
        <p className="text-xs text-emerald-700 mb-1">Consistently Demonstrated</p>
        <p className="text-3xl font-bold text-emerald-700">{excellentRate ?? '—'}</p>
      </CardContent>
    </Card>
  </div>
);
